import React from "react";

export default function Sidenav(props) {
  const { showNav, changeNav, setShowNav } = props;
  

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setShowNav(false); // Close mobile nav if open
  };

  return (
    <div
      className={
        showNav
          ? "flex justify-center items-center fixed bg-slate-500 bg-opacity-80 top-0 min-h-[100vh] w-[100%] text-text-color-dark md:hidden z-[999]"
          : "hidden"
      }
    >
      <div className="bg-secondary-color w-[30vmax] min-h-[40vmax] rounded-md ">
        <div className="flex flex-col justify-center items-center h-full text-xl font-bold tracking-widest px-8">
          <div className="p-10">
            <button className="font-sub-font text-4xl tracking-widest" onClick={() => scrollToSection('home')}>
              hs
            </button>
          </div>
          <div className=" gap-y-10  flex flex-col justify-center items-center">
            <button
              onClick={() => scrollToSection('projects')}
            >
              PROJECTS
            </button>
            <button
              onClick={() => scrollToSection('contact')}
            >
              CONTACT
            </button>
          </div>
          <div
            className="bg-primary-color min-w-[30px] min-h-[30px] rounded-full my-10 flex justify-center items-center text-white cursor-pointer hover:scale-90 duration-300"
            onClick={() => {
              changeNav();
            }}
          >
            <svg width="20px" height="20px" viewBox="0 0 32 32" version="1.1">
              <g id="icomoon-ignore"></g>
              <path
                d="M10.722 9.969l-0.754 0.754 5.278 5.278-5.253 5.253 0.754 0.754 5.253-5.253 5.253 5.253 0.754-0.754-5.253-5.253 5.278-5.278-0.754-0.754-5.278 5.278z"
                fill="#FFF4F4"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
